import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function VerifySuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Store token
      localStorage.setItem('token', token);
      
      // Success message
      setStatus('success');
      
      // Redirect to dashboard after 3 seconds
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload(); // Refresh to load user data
      }, 3000);
    } else {
      setStatus('error');
    }
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #f0f9ff 0%, #ffffff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        maxWidth: '500px',
        width: '100%',
        padding: '3rem',
        textAlign: 'center',
        border: '1px solid #e2e8f0'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <h1 style={{ fontSize: '1.5rem', color: '#334155', marginBottom: '0.5rem', fontWeight: '700' }}>
              Wird verifiziert...
            </h1>
            <p style={{ color: '#64748b' }}>
              Einen Moment bitte
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ 
              width: '80px', 
              height: '80px', 
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 2rem',
              fontSize: '3rem',
              color: 'white',
              boxShadow: '0 4px 14px rgba(16, 185, 129, 0.3)'
            }}>
              ✓
            </div>
            <h1 style={{ fontSize: '2rem', color: '#334155', marginBottom: '1rem', fontWeight: '700' }}>
              Email bestätigt! 🎉
            </h1>
            <p style={{ color: '#64748b', fontSize: '1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
              Ihr 14-Tage Testzugang wurde aktiviert.
            </p>
            <div style={{
              background: '#f0f9ff',
              border: '1px solid #bfdbfe',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1.5rem'
            }}>
              <p style={{ color: '#1e40af', fontSize: '0.9rem', margin: 0 }}>
                Sie werden automatisch zum Dashboard weitergeleitet...
              </p>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
            <h1 style={{ fontSize: '1.5rem', color: '#334155', marginBottom: '0.5rem', fontWeight: '700' }}>
              Fehler bei der Verifizierung
            </h1>
            <p style={{ color: '#64748b', marginBottom: '2rem' }}>
              Der Verifizierungs-Link ist ungültig oder abgelaufen.
            </p>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: '#2563eb',
                color: 'white',
                padding: '0.75rem 2rem',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 14px rgba(37, 99, 235, 0.3)',
                transition: 'all 0.3s'
              }}
              onMouseOver={(e) => e.target.style.background = '#1d4ed8'}
              onMouseOut={(e) => e.target.style.background = '#2563eb'}
            >
              Zum Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifySuccess;